module.exports = __webpack_public_path__ + "static/media/Professora.18b29a77.png";